import { Injectable } from '@angular/core';
import { NetService } from './net.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicantService {

constructor(
  private netService: NetService
) { }

  applicantLogin(phoneNumber: string) {
    return this.netService.getJavaApplicantNoHeaders('login/code', {phoneNumber: phoneNumber})
  }

  applicantSendCode(data: { code: string, phoneNumber: string }) {
    return this.netService.getJavaApplicant('login/application', {
      phoneNumber: data.phoneNumber.substring(1),
      code: data.code
    })
  }
}
